<template>
	<v-dialog id="type-preview-dialog" persistent max-width="1110" v-model="dialog" class="text-center"
		overlay-color="black">
		<div class="preview-actions">
			<div>
				<v-btn class="close-button" color="#d50606" @click="close">
					{{$t("generics.cancel")}}
				</v-btn>
			</div>
			<div>
				<span class="type-name">{{ this.translatedName }}</span>
			</div>
			<div>

			</div>
		</div>
		<v-progress-circular indeterminate color="white" class="loader" v-if="loading"></v-progress-circular>
		<div id="iframe-container">
			<iframe :src="src" ref="iframe" class="mx-auto" @load="loading = false"
				@loadstart="loading = true" />
		</div>
		<div class="preview-actions">
			<div>
				<a v-if="type.help_link" :href="type.help_link" class="help_link" target="_blank">
					<v-img max-width="30" src="/img/help_wheel.png" class="d-inline-block" />
				</a>
			</div>
			<div>
				<v-btn @click="createGame" color="#f03573" btn v-bind="$attrs" width="220" height="27" depressed
					class="assistant" rounded>
					<span class="assistant">{{$t("pages.preview_game.createGame")}}</span>
				</v-btn>
			</div>
			<div>

			</div>
		</div>
	</v-dialog>
</template>

<script>
import GameModule from "src/store/modules/Game.module";
import { gameTypeTranslate } from "src/helpers/Utilities";

export default {
	name: "TypePreviewDialog",
	props: {
		value: { type: Boolean },
		type: { type: Object, required: true }
	},
	data() {
		return {
			loading: true,
			iframeReady: false
		};
	},
	computed: {
		auth() {
			return this.$store.state.AuthModule.user;
		},
		translatedName() {
        return gameTypeTranslate(this.type.name);
		},
		dialog: {
			get() {
				return this.value;
			},
			set(val) {
				this.$emit("input", val);
			},
		},
		src() {
			let src;
			if (this.type && this.type.preview_iframe_override != null && this.type.preview_iframe_override != 'null') {
				src = this.type.preview_iframe_override;
			} else {
				src = `https://claplab-games.clap.co.il/?gameLoad`;
			}
			// if (this.displayView === "mobile") src += "&mobileView=true";
			src += "&previewMode&exampleMode=1";

      if(!this.type.can_live_edit) // show desktop view always for team games (until the mobile version will be OK)
        src += "&desktopView=true";
			return src;
		},
    canCreateGame() {
      return this.$store.getters.canCreateGame;
    },

	},
	methods: {
		close() {
			this.loading = true;
			this.$emit("close");
		},
    createGame() {
      if (!this.canCreateGame) {
        this.$emit("upgrade")
        return;
      }
			const types = GameModule.types;
			const data = {
				name: this.translatedName + " - " + this.auth.name,
				type_id: this.type.id,
				share: true
			};
			this.$store.dispatch(types.SAVE, data).then((game) => {
				this.$store.commit(types.GET, game);
				this.$store.commit(types.SHOW_IN_TOOLBAR, true);
				this.$router.push({
					name: "game-form",
					params: { id: game.id },
				});
			})
		},
		receiveMessage(event) {
			// if (event.origin !== "https://closeapp.co.il")
			// 	return;
			if (event.data.action === "iframeReady") {
				this.iframeReady = true;
				this.sendJson(event.source);
			}
		},
		sendJson() {
			window.popup = this.$refs.iframe;
			if (window.popup)
				window.popup.contentWindow.postMessage(
					{
						action: "getJson",
						json: JSON.parse(this.type.json),
						language: this.$i18n.locale
					},
					"*"
				);
		},
		postIframe() {
			let iframe = this.$refs.iframe;
			if (iframe) {
				iframe.onload = () => {
					this.sendJson();
				};
			}
		}
	},
	created() {
		window.addEventListener("message", this.receiveMessage);
		if (this.iframeReady)
			this.sendJson();
		else
			this.postIframe();
	},
	destroyed() {
		window.removeEventListener("message", this.receiveMessage);
	}
};
</script>

<style scoped lang="scss">
.loader {
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
}

.type-help-dialog {
	position: relative;
}

#iframe-container {
	position: relative;
	width: 100%;
	background-color: white;
}

iframe {
  width: 100%;
  height: 75vh;
}

@media (max-width: 600px) {
  //iframe {
  //  width: 90vw;
  // // height: calc(90vw/1.77);
  //  height: 90vh;
  //}
}

.close-button {
	color: white !important;
	height: 28px !important;
}

.preview-actions {
  display: flex;
  justify-content: space-between;
  background-color: white;
  padding: 5px;
}

.assistant {
  font-family: Assistant, sans-serif;
  font-style: normal;
  color: #fff;
}

.type-name {
  font-size: 1.2em;
  font-weight: bold;
}
</style>
